// Author : NANDHAKUMAR
// Version :0.0.1
// MODIFIED DATE: 14/11/2025
const memberCollectionActionTypes = {
	/************************ GET SEARCH MEMBER LOAN LIST START ****************** */
	GET_SEARCH_MEMBER_LOAN_LIST_START: 'get_search_member_loan_list_start',
	GET_SEARCH_MEMBER_LOAN_LIST_SUCCESS: 'get_search_member_loan_list_success',
	GET_SEARCH_MEMBER_LOAN_LIST_FAILURE: 'get_search_member_loan_list_failure',
	GET_SEARCH_MEMBER_LOAN_LIST_RESPONSE_RESET: 'get_search_member_loan_list_response_reset',
	GET_SEARCH_MEMBER_LOAN_LIST_RESPONSE_CHANGED: 'get_search_member_loan_list_response_changed',
	/************************ GET SEARCH MEMBER LOAN LIST END ****************** */

	/************************ GET SEARCH MEMBER LOAN INFO START ****************** */
	GET_MEMBER_LOAN_INFO_START: 'get_member_loan_info_start',
	GET_MEMBER_LOAN_INFO_SUCCESS: 'get_member_loan_info_success',
	GET_MEMBER_LOAN_INFO_FAILURE: 'get_member_loan_info_failure',
	GET_MEMBER_LOAN_INFO_RESPONSE_RESET: 'get_member_loan_info_response_reset',
	GET_MEMBER_LOAN_INFO_RESPONSE_CHANGED: 'get_member_loan_info_response_changed',
	/************************ GET SEARCH MEMBER LOAN INFO END ****************** */

	/************************ UPDATE MEMBER COLLECTION START ****************** */
	UPDATE_MEMBER_COLLECTION_START: 'update_member_collection_start',
	UPDATE_MEMBER_COLLECTION_SUCCESS: 'update_member_collection_success',
	UPDATE_MEMBER_COLLECTION_FAILURE: 'update_member_collection_failure',
	UPDATE_MEMBER_COLLECTION_RESPONSE_RESET: 'update_member_collection_reponse_start',
	UPDATE_MEMBER_COLLECTION_RESPONSE_CHANGED: 'update_member_collection_reponse_changed',
	/************************ UPDATE MEMBER COLLECTION END ****************** */

	/************************ UPDATE MEMBER DEATH START ****************** */
	UPDATE_MEMBER_DEATH_START: 'update_member_death_start',
	UPDATE_MEMBER_DEATH_SUCCESS: 'update_member_death_success',
	UPDATE_MEMBER_DEATH_FAILURE: 'update_member_death_failure',
	UPDATE_MEMBER_DEATH_RESPONSE_RESET: 'update_member_death_response_reset',
	UPDATE_MEMBER_DEATH_RESPONSE_CHANGED: 'update_member_death_reponse_changed',
	/************************ UPDATE MEMBER DEATH START ****************** */

	/************************ UPDATE INTEREST WAIVER START****************** */
	UPDATE_INTEREST_WAIVER_START: 'update_interest_waiver_start',
	UPDATE_INTEREST_WAIVER_SUCCESS: 'update_interest_waiver_success',
	UPDATE_INTEREST_WAIVER_FAILURE: 'update_interest_waiver_failure',
	UPDATE_INTEREST_WAIVER_RESPONSE_RESET: 'update_interest_waiver_response_reset',
	UPDATE_INTEREST_WAIVER_RESPONSE_CHANGED: 'update_interest_waiver_response_changed',
	/************************ UPDATE INTEREST WAIVER END****************** */

	/************************ GET MEMBER COLLECTION START ****************** */
	GET_MEMBER_COLLECTION_START: 'get_member_collection_start',
	GET_MEMBER_COLLECTION_SUCCESS: 'get_member_collection_success',
	GET_MEMBER_COLLECTION_FAILURE: 'get_member_collection_failure',
	GET_MEMBER_COLLECTION_RESPONSE_RESET: 'get_member_collection_response_reset',
	GET_MEMBER_COLLECTION_RESPONSE_CHANGED: 'get_member_collection_response_changed',
	/************************ GET MEMBER COLLECTION END ****************** */

	/************************ GET MEMBER WALLET START ****************** */
	GET_MEMBER_WALLET_START: 'get_member_wallet_start',
	GET_MEMBER_WALLET_SUCCESS: 'get_member_wallet_success',
	GET_MEMBER_WALLET_FAILURE: 'get_member_wallet_failure',
	GET_MEMBER_WALLET_RESPONSE_RESET: 'get_member_wallet_response_reset',
	GET_MEMBER_WALLET_RESPONSE_CHANGED: 'get_member_wallet_response_changed',
	/************************ GET MEMBER WALLET END ****************** */

	/************************ ADD MEMBER WALLET START ****************** */
	ADD_MEMBER_WALLET_START: 'add_member_wallet_start',
	ADD_MEMBER_WALLET_SUCCESS: 'add_member_wallet_success',
	ADD_MEMBER_WALLET_FAILURE: 'add_member_wallet_failure',
	ADD_MEMBER_WALLET_RESPONSE_RESET: 'add_member_wallet_reset',
	ADD_MEMBER_WALLET_RESPONSE_CHANGED: 'add_member_wallet_change',
	/************************ ADD MEMBER WALLET END ****************** */

	/************************ GET MEMBER QR START ****************** */
	GET_MEMBER_QR_START: 'get_member_qr_start',
	GET_MEMBER_QR_SUCCESS: 'get_member_qr_success',
	GET_MEMBER_QR_FAILURE: 'get_member_qr_failure',
	GET_MEMBER_QR_RESPONSE_RESET: 'get_member_qr_response_reset',
	GET_MEMBER_QR_RESPONSE_CHANGED: 'get_member_qr_response_changed',
	/************************ GET MEMBER QR END ****************** */

	/************************ GET MEMBER REPAYMENT START****************** */
	GET_MEMBER_REPAYMENT_START: 'get_member_repayment_start',
	GET_MEMBER_REPAYMENT_SUCCESS: 'get_member_repayment_success',
	GET_MEMBER_REPAYMENT_FAILURE: 'get_member_repayment_failure',
	GET_MEMBER_REPAYMENT_RESPONSE_RESET: 'get_member_repayment_response_reset',
	GET_MEMBER_REPAYMENT_RESPONSE_CHANGED: 'get_member_repayment_response_changed',
	/************************ GET MEMBER REPAYMENT END ****************** */

	/************************ DELETE MEMBER WALLET START ****************** */
	DELETE_MEMBER_WALLET_START: 'delete_member_wallet_start',
	DELETE_MEMBER_WALLET_SUCCESS: 'delete_member_wallet_success',
	DELETE_MEMBER_WALLET_FAILURE: 'delete_member_wallet_failure',
	DELETE_MEMBER_WALLET_RESPONSE_RESET: 'delete_member_wallet_response_reset',
	DELETE_MEMBER_WALLET_RESPONSE_CHANGED: 'delete_member_wallet_response_changed',
	/************************ DELETE MEMBER WALLET END ****************** */

	/************************ REVERT MEMBER COLLECTION START ****************** */
	REVERT_MEMBER_COLLECTION_START: 'revert_member_collection_start',
	REVERT_MEMBER_COLLECTION_SUCCESS: 'revert_member_collection_success',
	REVERT_MEMBER_COLLECTION_FAILURE: 'revert_member_collection_failure',
	REVERT_MEMBER_COLLECTION_RESPONSE_RESET: 'revert_member_collection_response_reset',
	REVERT_MEMBER_COLLECTION_RESPONSE_CHANGED: 'revert_member_collection_response_changed',
	/************************ REVERT MEMBER COLLECTION END ****************** */

	/************************ MEMBER LOAN CARD PDF DEATAILS START ****************** */
	MEMBER_LOAN_CARD_PDF_START: 'member_loan_card_pdf_start',
	MEMBER_LOAN_CARD_PDF_SUCCESS: 'member_loan_card_pdf_success',
	MEMBER_LOAN_CARD_PDF_FAILURE: 'member_loan_card_pdf_failure',
	MEMBER_LOAN_CARD_PDF_RESPONSE_RESET: 'member_loan_card_pdf_response_reset',
	MEMBER_LOAN_CARD_PDF_RESPONSE_CHANGED: 'member_loan_card_pdf_response_changed',
	/************************ MEMBER LOAN CARD DEATAILS END ****************** */

	/************************ MEMBER REPAYMENT PDF DEATAILS START ****************** */
	MEMBER_REPAYMENT_PDF_START: 'member_repayment_pdf_start',
	MEMBER_REPAYMENT_PDF_SUCCESS: 'member_repayment_pdf_success',
	MEMBER_REPAYMENT_PDF_FAILURE: 'member_repayment_pdf_failure',
	MEMBER_REPAYMENT_PDF_RESPONSE_RESET: 'member_repayment_pdf_response_reset',
	MEMBER_REPAYMENT_PDF_RESPONSE_CHANGED: 'member_repayment_pdf_response_changed',
	/************************ MEMBER REPAYMENT DEATAILS END ****************** */

	/************************ MEMBER LOAN CARD REPORT START ****************** */
	MEMBER_LOAN_CARD_REPORT_START: 'member_loan_card_report_start',
	MEMBER_LOAN_CARD_REPORT_SUCCESS: 'member_loan_card_report_success',
	MEMBER_LOAN_CARD_REPORT_FAILURE: 'member_loan_card_report_failure',
	MEMBER_LOAN_CARD_REPORT_RESPONSE_RESET: 'member_loan_card_report_response_reset',
	MEMBER_LOAN_CARD_REPORT_RESPONSE_CHANGED: 'member_loan_card_report_response_changed',
	/************************ MEMBER LOAN CARD REPORT END ****************** */

	/************************ MEMBER LOAN COLLECTION APPROVAL START ****************** */
	MEMBER_LOAN_COLLECTION_APPROVAL_START: 'member_loan_collection_approval_start',
	MEMBER_LOAN_COLLECTION_APPROVAL_SUCCESS: 'member_loan_collection_approval_success',
	MEMBER_LOAN_COLLECTION_APPROVAL_FAILURE: 'member_loan_collection_approval_failure',
	MEMBER_LOAN_COLLECTION_APPROVAL_RESPONSE_RESET:
		'member_loan_collection_approval_response_reset',
	MEMBER_LOAN_COLLECTION_APPROVAL_RESPONSE_CHANGED:
		'member_loan_collection_approval_response_changed',
	/************************ MEMBER LOAN COLLECTION APPROVAL END ****************** */

	/************************ MEMBER LOAN COLLECTION LOAN PAID START ****************** */
	MEMBER_COLLECTION_LOAN_PAID_ENTRY_START: 'member_collection_loan_paid_entry_start',
	MEMBER_COLLECTION_LOAN_PAID_ENTRY_SUCCESS: 'member_collection_loan_paid_entry_success',
	MEMBER_COLLECTION_LOAN_PAID_ENTRY_FAILURE: 'member_collection_loan_paid_entry_failure',
	MEMBER_COLLECTION_LOAN_PAID_ENTRY_REPONSE_RESET:
		'member_collection_loan_paid_entry_response_reset',
	MEMBER_COLLECTION_LOAN_PAID_ENTRY_RESPONSE_CHANGED:
		'member_collection_loan_paid_entry_response_changed',
	/************************ MEMBER LOAN COLLECTION LOAN PAID END ****************** */

	/************************ MEMBER LOAN COLLECTION LOAN PAID ARREAR START ****************** */
	MEMBER_COLLECTION_LOAN_PAID_ARREAR_ENTRY_START:
		'member_collection_loan_paid_arrear_entry_start',
	MEMBER_COLLECTION_LOAN_PAID_ARREAR_ENTRY_SUCCESS:
		'member_collection_loan_paid_arrear_entry_success',
	MEMBER_COLLECTION_LOAN_PAID_ARREAR_ENTRY_FAILURE:
		'member_collection_loan_paid_arrear_entry_failure',
	MEMBER_COLLECTION_LOAN_PAID_ARREAR_ENTRY_REPONSE_RESET:
		'member_collection_loan_paid_arrear_entry_response_reset',
	MEMBER_COLLECTION_LOAN_PAID_ARREAR_ENTRY_RESPONSE_CHANGED:
		'member_collection_loan_paid_arrear_entry_response_changed',
	/************************ MEMBER LOAN COLLECTION LOAN PAID ARREAR END ****************** */

	/************************ GET THRIFT COLLECTION DETAILS START ****************** */
	GET_THRIFT_COLLECTION_DETAILS_START: 'get_thrift_collection_details_start',
	GET_THRIFT_COLLECTION_DETAILS_SUCCESS: 'get_thrift_collection_details_success',
	GET_THRIFT_COLLECTION_DETAILS_FAILURE: 'get_thrift_collection_details_failure',
	GET_THRIFT_COLLECTION_DETAILS_RESPONSE_RESET: 'get_thrift_collection_details_response_reset',
	GET_THRIFT_COLLECTION_DETAILS_RESPONSE_CHANGED:
		'get_thrift_collection_details_response_changed',
	/************************ GET THRIFT COLLECTION DETAILS END ****************** */

	/************************ REVERT THRIFT COLLECTION START ****************** */
	REVERT_THRIFT_COLLECTION_START: 'revert_thrift_collection_start',
	REVERT_THRIFT_COLLECTION_SUCCESS: 'revert_thrift_collection_success',
	REVERT_THRIFT_COLLECTION_FAILURE: 'revert_thrift_collection_failure',
	REVERT_THRIFT_COLLECTION_RESPONSE_RESET: 'revert_thrift_collection_response_reset',
	REVERT_THRIFT_COLLECTION_RESPONSE_CHANGED: 'revert_thrift_collection_response_changed',
	/************************ REVERT THRIFT COLLECTION END ****************** */
};
export default memberCollectionActionTypes;
